module.exports = __webpack_public_path__ + "static/media/yiziming.49381c90.png";